// Iter122g · Helper riutilizzabile per evidenziare in giallo il testo che
// combacia con una query di ricerca (case-insensitive, accento-insensitive).
// Restituisce un array di ReactNode adatto ad essere renderizzato direttamente.
import React from "react";

const stripDia = (s) => (s || "").normalize("NFD").replace(/\p{Diacritic}/gu, "");

export function highlightMatch(text, query, className = "bg-yellow-200 rounded-sm px-0.5") {
  const src = text == null ? "" : String(text);
  const q = (query || "").trim();
  if (!q) return src;

  const hayNorm = stripDia(src).toLowerCase();
  const needleNorm = stripDia(q).toLowerCase();
  if (!needleNorm) return src;

  const out = [];
  let cursor = 0;
  let idx = hayNorm.indexOf(needleNorm, cursor);
  while (idx !== -1) {
    if (idx > cursor) out.push(src.slice(cursor, idx));
    out.push(
      <mark key={`hl-${idx}`} className={className}>
        {src.slice(idx, idx + needleNorm.length)}
      </mark>
    );
    cursor = idx + needleNorm.length;
    idx = hayNorm.indexOf(needleNorm, cursor);
  }
  if (cursor < src.length) out.push(src.slice(cursor));
  return out;
}

export default highlightMatch;
